'use strict';

import axios from 'axios'
import qs from 'qs'
// import { Message } from 'element-ui'
import Vue from 'vue';

let localhosts = window.globalUrl;   //域名

const processToken = (conf) => {
  const token = localStorage.getItem('CRIC_TOKEN')
  if (token) {
    conf.headers.common['Authorization'] = token
  }
  return conf
}

axios.interceptors.request.use(config => {
  // loading
  return processToken(config)
}, error => {
  return Promise.reject(error)
});

axios.interceptors.response.use(response => {
  if (response.data.status === 401) {
    let newError = response.data
    if (newError['status'] == 401) {
      localStorage.removeItem("CRIC_USERID");
      localStorage.removeItem("CRIC_TOKEN");
      // Message({
      //   message: '登录过期,请重新登录',
      //   type: 'error',
      // });
      window.location = '/login'
      return
    }
  } else if (response.data.status === 403) {
    if (response.data.redirect) {
      window.location = '/forbidden'
    }
    return
    // console.log('res--->', response)
  } else if (response.data.status === 406) {
    window.location = '/busy'
    return
  } else if (response.data.status === 405) {
    window.location = '/disabled'
    return
  }

  return response
}, error => {
  return Promise.reject(error.message);
});

function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    return response
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return {
    status: 404,
    msg: '网络异常'
  }
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status === 404) {
    console.log(res)
  }
  if (res.data && (!res.data.success)) {
    // alert(res.data.error_msg)
  }
  return res
}

export default {
  delete(url, params, urlType = 'default') {
    const requestUrl = localhosts + window.serviceType[urlType]
    return axios({
      method: 'delete',
      baseURL: requestUrl,
      url,
      params, // get 请求时带的参数
      timeout: 0,
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  postExcel(url, data, urlType = 'default') {
    const requestUrl = localhosts + window.serviceType[urlType]
    return axios({
      method: 'post',
      baseURL: requestUrl,
      url,
      data: data,
      timeout: 0,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/vnd.ms-excel; charset=UTF-8',
      },
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  post(url, data, urlType = 'default') {
    const requestUrl = localhosts + window.serviceType[urlType]
    return axios({
      method: 'post',
      baseURL: requestUrl,
      url,
      data,
      timeout: 0,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  get(url, params, urlType = 'default') {
    const requestUrl = localhosts + window.serviceType[urlType]
    return axios({
      method: 'get',
      baseURL: requestUrl,
      url,
      params, // get 请求时带的参数
      timeout: 0,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  put(url, params, urlType = 'default') {
    const requestUrl = localhosts + window.serviceType[urlType]
    return axios({
      method: 'put',
      baseURL: requestUrl,
      url,
      params, // get 请求时带的参数
      timeout: 0,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  }
}
